import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapy',
})
export class Therapy2Pipe implements PipeTransform {
  transform(value: any) {
    if (value === 'undefined' || isNaN(value)) {
      return 'sonstige Dokumente';
    }

    const retVal = Therapies.therapyItems.find(therapyItem => therapyItem.id === Number(value));

    if (retVal) {
      return retVal.displayName;
    }
  }
}
